/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GoogleCalendarConnectResponseDto
 */
export interface GoogleCalendarConnectResponseDto {
    /**
     * URL to redirect the provider to for Google OAuth consent
     * @type {string}
     * @memberof GoogleCalendarConnectResponseDto
     */
    authUrl: string;
}

/**
 * Check if a given object implements the GoogleCalendarConnectResponseDto interface.
 */
export function instanceOfGoogleCalendarConnectResponseDto(value: object): value is GoogleCalendarConnectResponseDto {
    if (!('authUrl' in value) || value['authUrl'] === undefined) return false;
    return true;
}

export function GoogleCalendarConnectResponseDtoFromJSON(json: any): GoogleCalendarConnectResponseDto {
    return GoogleCalendarConnectResponseDtoFromJSONTyped(json, false);
}

export function GoogleCalendarConnectResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleCalendarConnectResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'authUrl': json['authUrl'],
    };
}

export function GoogleCalendarConnectResponseDtoToJSON(json: any): GoogleCalendarConnectResponseDto {
    return GoogleCalendarConnectResponseDtoToJSONTyped(json, false);
}

export function GoogleCalendarConnectResponseDtoToJSONTyped(value?: GoogleCalendarConnectResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'authUrl': value['authUrl'],
    };
}

